import { AssetType } from '../models/asset-type'

export type FrameWidgetUniquenessResult
  = | { valid: true }
    | { valid: false, message: string }

/** Minimal frame shape for validation; avoids importing playlist and circular deps. */
export interface IFrameFacetsForValidation {
  facets: Record<string, { asset: string, type: string }>
}

/**
 * Validates that within a single frame, each widget asset appears in at most one section.
 * Used by playlist/campaign editors and API on save.
 */
export function validateFrameWidgetUniqueness(
  frame: IFrameFacetsForValidation
): FrameWidgetUniquenessResult {
  const widgetAssets: string[] = []
  for (const facet of Object.values(frame.facets)) {
    if (facet.type === AssetType.Widget) {
      widgetAssets.push(facet.asset)
    }
  }
  const seen = new Set<string>()
  for (const urn of widgetAssets) {
    if (seen.has(urn)) {
      return {
        valid: false,
        message: `Widget asset ${urn} appears in more than one section of the same frame; each widget may be used in at most one section per frame.`
      }
    }
    seen.add(urn)
  }
  return { valid: true }
}
